import {
  IComponentModel,
  IListComponentModel,
  IMediaMapperOptions,
  MediaCategoryType,
  MediaImageType,
} from "@nf/common";
import { ROUTES } from "@nf/constants";
import { GetServerSideProps } from "next";

import { captureMessage } from "@sentry/nextjs";
import { getCommonServerSideProps } from "../../../../helpers/getCommonServerSideProps";

import MainScreen from "screens/MainScreen";

const MediaMapperOptions: IMediaMapperOptions = {
  ExcludeArticle: true,
  ExcludeArticleFromCategories: true,
  ExcludeDescriptionFromCategories: true,
  ExcludeImagesFromCategories: true,
  ExcludeCategoryType: [
    MediaCategoryType.Channel,
    MediaCategoryType.Format,
    MediaCategoryType.Label,
    MediaCategoryType.Other,
  ],
  ExcludeSeasons: true,
  ExcludeSubtitles: true,
  ExcludeExtendedDescription: true,
  ExcludeContentAdvisory: true,
  ExcludeLongDescription: true,
  ExcludePeople: true,
  ExcludeMedia: true,
  ExcludeImageType: [
    MediaImageType.Banner,
    MediaImageType.Hero_Asset_Details,
    MediaImageType.Hover_Asset,
    MediaImageType.Highlight_Asset_Details,
    MediaImageType.Logo,
    MediaImageType.Square,
    MediaImageType.Cover,
    MediaImageType.Poster,
  ],
};

export const getServerSideProps: GetServerSideProps = async (ctx: any) => {
  const setCacheHeader = await import("helpers").then(
    (mod) => mod.setCacheHeader
  );
  const getComponentsMediaListData = await import("SSRUtils").then(
    (mod) => mod.getComponentsMediaListData
  );

  const { commonProps, DataProvider } = await getCommonServerSideProps(ctx);

  setCacheHeader(ctx.res);

  try {
    const screenData = await DataProvider.getScreenConfiguration(
      ctx.params.id,
      undefined,
      MediaMapperOptions
    );

    const componentData: IComponentModel[] = await getComponentsMediaListData(
      screenData?.Components as IListComponentModel[]
    );

    return {
      props: {
        ...commonProps,
        componentData,
        screenData,
      },
    };
  } catch (e: any) {
    captureMessage(e.Message, {
      level: "warning",
      tags: {
        componentConfiguration: ctx?.params?.id,
        error: e,
      },
    });
    return {
      redirect: {
        destination: `/${commonProps.country}/${commonProps.language}${ROUTES.PAGE_NOT_FOUND}`,
      },
      props: {
        ...commonProps,
      },
    };
  }
};

export default MainScreen;
